import { TradingOfferOperationStatus } from 'types/TradingOfferOperation';
import { TradingOfferOperationDetailContextType } from '../types/TradingOfferOperationDetailContextType';

export const tradingOfferOperationDetailInitValue: TradingOfferOperationDetailContextType =
  {
    data: {
      societyId: '',
      societyName: '',
      operation: null,
      tradingOffer: null,
      operationReference: '',
      operationStatus: TradingOfferOperationStatus.PENDING,
      timelineSteps: [],
      buyerInfo: null,
      sellerInfo: null,
      isAdmin: false,
      isLoading: true,
      partnerId: '',
      userDocumentRole: null,
      canPostComment: false,
    },
    actions: {
      handleGoBack: () => {},
      handleUpdateStatus: () => {},
      handleGoToOffer: () => {},
      handleRefreshOperation: async () => {},
      handleAddComment: async () => {},
      handleRemoveComment: async () => {},
    },
  };
